<div class="status-wrapper">
  <div class="status" [ngClass]="DocumentStatus[status!] | lowercase">
    {{ status | documentStatus }}
  </div>
</div>
